/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

const baseUrl = 'personalization';
function freeze(value) {
  return Object.freeze(value);
}

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/personalization/v1/case-study
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:CaseStudyResource+type:symbol+getCaseStudies&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Case_Study-get-%2Fpersonalization%2Fv1%2Fcase-study'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fpersonalization%2Fv1%2Fcase-study?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getCaseStudiesRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/case-study'])
});

/**
 * An RPC descriptor generated by client-types. Meant to be passed
 * to an RPC client function created by `createRpcClientV2` from
 * `rpc-client-utils`.
 *
 * get-/personalization/v1/recommendation/ml/hub-tier
 *
 * <span style='display: flex; justify-content: space-between;'><span style='flex: 1'><span style='display: inline-block;'>Auth Level: app ([Docs](https://product.hubteam.com/docs/appsystems/auth-and-rest/auth-levels.html)) | [Source Code](https://sourcegraph.hubteam.com/search?q=context:global+lang:Java+file:MlRecommendationResource+type:symbol+getInferenceHubTier&patternType=standard&sm=1&groupBy=repo) | <a href='#operations-Ml_Recommendation-get-%2Fpersonalization%2Fv1%2Frecommendation%2Fml%2Fhub-tier'>Permalink</a> | [API Goggles](https://tools.hubteam.com/api/get/api.hubapi.com%2Fpersonalization%2Fv1%2Frecommendation%2Fml%2Fhub-tier?showRequestDetails=true&body=&authType=app)</span></span><span style='padding-left: 12px'></span></span>
 */
export const getInferenceHubTierRpc = freeze({
  baseUrl,
  method: 'get',
  pathSegments: freeze(['v1/recommendation/ml/hub-tier'])
});